import { css } from "styled-components";
import { LegacyBladeHeader, BladeHeaderSupertitle } from "../../../../components/BladeHeader";
import { CarouselSlide } from "../../../../components/Carousel";
export const riotProductSkin = (chroma, paletteTokens) => css `
  & {
    padding: ${chroma.spacers.bladeEdge.top} 0 ${chroma.spacers.bladeEdge.bottom};
    display: flex;
    position: relative;
    max-width: ${chroma.dimensions.pageWidth};
    width: 100%;
    margin: 0 auto;
    flex-direction: column;
    background-color: ${paletteTokens.bladebg1};
  }

  .backdrop {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
  }
  ${LegacyBladeHeader} {
    padding: 0 ${chroma.spacers.variable.l} ${chroma.spacers.variable.m};
    ${BladeHeaderSupertitle} {
      padding-bottom: 0;
    }
  }

  ${CarouselSlide} {
    min-width: 55%;
    ${chroma.mediaQueries.tabletDown} {
      min-width: 95%;
    }
  }
`;
//# sourceMappingURL=index.js.map